<template>
  <div class="container mescroll-touch">
    <div class="goPersonal" @click="toLiveHome">
      <img src="../../assets/images/arrow_forward.png" />
      <span>星光</span>
    </div>
    <div class="userInfoBox">
      <div class="userInfo">
        <div class="touxiang">
          <img src="@/assets/images/headSculpture1.png" alt="" />
        </div>
        <div class="info">
          <p class="name">{{ userDetails.UserName }}</p>
          <p class="positionalName">{{ userDetails.PositionalName }}</p>
        </div>
      </div>
      <div class="hospital">
        <img class="hospitalIcon" src="@/assets/images/hospital@2x.png" alt="" />
        <span>{{ userDetails.HospitalTitle }}</span>
      </div>
      <div class="hospital">
        <img class="keshiIcon" src="@/assets/images/keshi@2x.png" alt="" />
        <span>{{ userDetails.SubjectName }}</span>
      </div>
      <div class="dataBox">
        <div class="dataItem" @click="toFansFollowList('followers')">
          <span class="dataNum">{{ userDetails.FansCount }}</span>
          <span class="dataName" v-if="userInfo.Type != 3">粉丝</span>
          <span class="dataName" v-if="userInfo.Type == 3">Followers</span>
          <img class="dashed" src="@/assets/images/dashed.png" alt="">
        </div>
        <div class="dataItem" @click="toFansFollowList('following')">
          <span class="dataNum">{{ userDetails.AttentionCount }}</span>
          <span class="dataName" v-if="userInfo.Type != 3">关注</span>
          <span class="dataName" v-if="userInfo.Type == 3">Following</span>
          <img class="dashed" src="@/assets/images/dashed.png" alt="">
        </div>
        <div class="dataItem" @click="showFavorites">
          <span class="dataNum">{{ userDetails.LikeAndCollectCount }}</span>
          <span class="dataName" v-if="userInfo.Type != 3">获赞与收藏</span>
          <span class="dataName" v-if="userInfo.Type == 3">Favorites</span>
        </div>
      </div>
      <template v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id">
        <div class="shareBox" v-if="userInfo.Type != 3">
          <img class="shareIcon" src="@/assets/images/share.png" alt="" @click="toPersonalPoster" />
        </div>
        <div class="customerServiceBox" :class="{'customerServiceBox_en' : userInfo.Type == 3}">
          <img class="customerServiceIcon" src="@/assets/images/customerService.png" alt="" @click="CustomerServicePopup = true" />
        </div>
      </template>
      <template v-else>
        <div class="followBtn follow" v-if="followState == 0" @click="follow">
          <img class="plusIcon" src="@/assets/images/follow.png" alt="" />
          <span v-if="userInfo.Type != 3">关注</span>
          <span v-if="userInfo.Type == 3">Follow</span>
        </div>
        <div class="followBtn unfollow" v-else @click="unFollow">
          <img class="plusIcon" src="@/assets/images/unfollow.png" alt="" />
          <span v-if="userInfo.Type != 3">已关注</span>
          <span v-if="userInfo.Type == 3">Unfollow</span>
        </div>
      </template>
    </div>
    <div class="menuBox" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id">
      <div class="menuItem" @click="toMyFavorite">
        <img src="@/assets/images/mydz.png" alt="" />
        <span v-if="userInfo.Type != 3">我的点赞</span>
        <span class="enMenuTitle" v-if="userInfo.Type == 3">Likes</span>
      </div>
      <div class="menuItem" @click="toMyCollection">
        <img src="@/assets/images/mysc.png" alt="" />
        <span v-if="userInfo.Type != 3">我的收藏</span>
        <span class="enMenuTitle" v-if="userInfo.Type == 3">Favorites</span>
      </div>
      <div class="menuItem" @click="toMyMeeting">
        <img src="@/assets/images/myhy.png" alt="" />
        <span v-if="userInfo.Type != 3">我的预约</span>
        <span class="enMenuTitle" v-if="userInfo.Type == 3">Events</span>
      </div>
      <div class="menuItem" @click="toBrowseRecords">
        <img src="@/assets/images/myjl.png" alt="" />
        <span v-if="userInfo.Type != 3">历史记录</span>
        <span class="enMenuTitle" v-if="userInfo.Type == 3">View History</span>
      </div>
    </div>
    <div class="contentBox" v-if="liveDetailes != null && Object.keys(liveDetailes).length > 0">
      <div class="contentTitle">
        <span v-if="userInfo.Type != 3">专属活动区</span>
        <span v-if="userInfo.Type == 3">Live Room</span>
      </div>
      <div class="liveBox" @click="toLive(liveDetailes.url)">
        <div class="liveCoverBox">
          <img class="liveCover" :src="liveDetailes.cover" alt="" />
          <img class="playIcon" src="../../assets/images/play_icon.png" />
          <div class="liveStatus" v-if="liveDetailes.event_type == 1">进行中</div>
        </div>
        <p class="liveTitle van-multi-ellipsis--l2">{{ liveDetailes.title }}</p>
      </div>
    </div>
    <div class="contentBox" v-if="albumList.length > 0">
      <div class="contentTitle">
        <span v-if="userInfo.Type != 3">我的专辑</span>
        <span v-if="userInfo.Type == 3">Content</span>
        <div class="viewAll" @click="viewAll">
          <span>查看全部</span>
          <van-icon class="moreIcon" name="arrow" />
        </div>
      </div>
      <div class="albumList">
        <div class="listItem" v-for="(item, index) in albumList" :key="index" @click="toAlbumDetails(item.Id)">
          <div class="albumCover">
            <img class="cover" :src="item.Url" />
            <img class="cornerMark" src="@/assets/images/album_cornerMark.png" />
          </div>
          <div class="albumTitle van-multi-ellipsis--l2">{{ item.Name }}</div>
        </div>
      </div>
    </div>
    <div class="contentBox">
      <div class="contentTitle">
        <span v-if="userInfo.Type != 3">内容</span>
        <span v-if="userInfo.Type == 3">Content</span>
      </div>
      <div class="articleList" v-if="articleList.length > 0">
        <div class="articleItem" v-for="(item, index) in articleList" :key="index" @click="toContentPage(item.Id, item.Type)">
          <div class="articleCover">
            <img :src="item.Thumbnail" alt="" />
            <div class="sourceTag" v-if="item.SourceContent && item.SourceLink">{{ item.SourceContent }}</div>
          </div>
          <div class="articleInfo">
            <p class="articleTitle van-multi-ellipsis--l2">{{ item.Title }}</p>
            <div class="articleData">
              <div class="operateBox">
                <div class="operateItem">
                  <img class="operateIcon watch" src="@/assets/images/personal_watch_active.png" alt="" />
                  <span>{{ item.WatchCount }}</span>
                </div>
                <div class="operateItem">
                  <img class="operateIcon like" src="@/assets/images/personal_like_active.png" alt="" />
                  <span>{{ item.LikeCount }}</span>
                </div>
                <div class="operateItem">
                  <img class="operateIcon collect" src="@/assets/images/personal_collect_active.png" alt="" />
                  <span>{{ item.CollectCount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="notContent" v-else>
        <div class="notContent_btn" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id" @click="CustomerServicePopup = true">
          <template v-if="userInfo.Type != 3">我要投稿</template>
          <template v-if="userInfo.Type == 3">Submit</template>
        </div>
        <span class="text" v-else>
          <template v-if="userInfo.Type != 3">未投稿</template>
          <template v-if="userInfo.Type == 3">No content available</template>
        </span>
      </div>
    </div>
    <div class="contentBox" v-if="liveDetailes == null">
      <div class="contentTitle">
        <span v-if="userInfo.Type != 3">专属活动区</span>
        <span v-if="userInfo.Type == 3">Live Room</span>
      </div>
      <div class="notContent">
        <span class="text" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id">
          <template v-if="userInfo.Type != 3">如您需要开展活动，请右上角联系客服</template>
          <template v-if="userInfo.Type == 3"></template>
        </span>
        <span class="text" v-else>
          <template v-if="userInfo.Type != 3">未开播</template>
          <template v-if="userInfo.Type == 3">No content available</template>
        </span>
      </div>
    </div>
    <div class="column" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id" @click="$router.push('/xgPrivacyPolicy')">
      <span v-if="userInfo.Type != 3">隐私声明</span>
      <span v-if="userInfo.Type == 3">Privacy Policy</span>
      <img src="@/assets/images/icon_right1.png" alt="" />
    </div>
    <div class="column" v-if="(!userId || userId == userInfo.Id) && userInfo.Type != 3" @click="$router.push('/userAgreement')">
      <span>用户协议</span>
      <img src="@/assets/images/icon_right1.png" alt="" />
    </div>
    <template v-if="userInfo.Type != 3">
      <div class="contactUs" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id">如果您有学术内容需要上传，欢迎点击<span @click="CustomerServicePopup = true">[联系方式]</span>，<br/>我们将为您提供专业的服务</div>
      <div class="unsubscribe" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id"><span @click="LogoutPopup = true">[注销账户]</span></div>
    </template>
    <template v-if="userInfo.Type == 3">
      <!-- <div class="contactUs" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id">Contact us<span @click="CustomerServicePopup = true">[Email]</span></div> -->
      <div class="unsubscribe" v-if="!OthersInfo.Id || OthersInfo.Id == userInfo.Id"><span @click="LogoutPopup = true">[Logout]</span></div>
    </template>
    <div class="toTop" @click="toTop">
      <a href="javascript:void(0)">
        <img src="@/assets/images/top_comm_icon@2x.png" />
      </a>
    </div>
    <van-popup class="FavoritesPopup" v-model="FavoritesPopup" :close-on-click-overlay="true">
      <div class="FavoritesBox">
        <template v-if="userInfo.Type != 3">
          <div class="FavoritesTitle">获赞与收藏</div>
          <div class="FavoritesContent">
            <div class="FavoritesItem">
              <img src="@/assets/images/myArticle.png" alt="" />
              <span class="title">当前发布内容数</span>
              <span class="num">{{ ArtCount }}</span>
            </div>
            <div class="FavoritesItem">
              <img src="@/assets/images/myLike.png" alt="" />
              <span class="title">当前获得点赞数</span>
              <span class="num">{{ LikeCount }}</span>
            </div>
            <div class="FavoritesItem">
              <img src="@/assets/images/myCollect.png" alt="" />
              <span class="title">当前获得收藏数</span>
              <span class="num">{{ CollectCount }}</span>
            </div>
            <div class="FavoritesConfirm" @click="FavoritesPopup = false">我知道了</div>
          </div>
        </template>
        <template v-else>
          <div class="FavoritesTitle">Likes and Favorites</div>
          <div class="FavoritesContent">
            <div class="FavoritesItem">
              <img src="@/assets/images/myArticle.png" alt="" />
              <span class="enTitle">Current Published Content</span>
              <span class="num">{{ ArtCount }}</span>
            </div>
            <div class="FavoritesItem">
              <img src="@/assets/images/myLike.png" alt="" />
              <span class="enTitle">Current Likes Received</span>
              <span class="num">{{ LikeCount }}</span>
            </div>
            <div class="FavoritesItem">
              <img src="@/assets/images/myCollect.png" alt="" />
              <span class="enTitle">Current Favorites Collected</span>
              <span class="num">{{ CollectCount }}</span>
            </div>
            <div class="FavoritesConfirm" @click="FavoritesPopup = false">OK</div>
          </div>
        </template>
      </div>
    </van-popup>
    <van-popup class="CustomerServicePopup" v-model="CustomerServicePopup" :close-on-click-overlay="false">
      <div class="close" @click="CustomerServicePopup = false">
        <van-icon class="closeIcon" name="cross" />
      </div>
      <div class="customerServiceQRcode">
        <template v-if="userInfo.Type != 3">
          <span>调整个人信息与投稿或开播等问题</span><br/>
          <span>请长按扫码联系客服</span>
        </template>
         <template v-else>
          <span>To Update Personal Information,</span><br/>
          <span>Submit Content, or Access Live Surgery,</span><br/>
          <span>Please long-press to scan the QR code and</span><br/>
          <span>contact customer service team.</span>
        </template>
        <div class="QRcodeBox">
          <div class="QRcode">
            <img src="@/assets/images/contactSupport.png" alt="" />
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup class="LogoutPopup" v-model="LogoutPopup" :close-on-click-overlay="false">
      <div class="close" @click="LogoutPopup = false">
        <van-icon class="closeIcon" name="cross" />
      </div>
      <template v-if="userInfo.Type != 3">
        <img class="warningIcon" src="@/assets/images/warning.png" alt="" />
        <span v-html="'是否确认<注销>'"></span><br/>
        <span style="font-weight: bold;">将删除所有用户记录，无法恢复。</span><br/>
        <span>如确认注销，请复制以下网址在浏览器这打开:</span><br/>
        <span style="overflow-wrap: break-word;word-break: break-all;">https://privacyportal.onetrust.com/webform/96f23ee1-34e3-41d6-8d5a-07f0d554152b/3034f16e-7700-486e-98c2-b2cbb05f4cd3?ApplicationName=XingGuangZhiBo</span>
      </template>
      <template v-else>
        <img class="warningIcon" src="@/assets/images/warning.png" alt="" />
        <span class="enLogoutTips">Confirm Account Deletion?</span><br/>
        <span class="enLogoutTips" style="font-weight: bold;">All user data will be permanently deleted and <br/>cannot be recovered.</span><br/>
        <span class="enLogoutTips">Please copy this URL to your browser:</span><br/>
        <span class="enLogoutTips" style="overflow-wrap: break-word;word-break: break-all;">https://privacyportal.onetrust.com/webform/96f23ee1-34e3-41d6-8d5a-07f0d554152b/3034f16e-7700-486e-98c2-b2cbb05f4cd3?ApplicationName=XingGuangZhiBo</span>
      </template>
    </van-popup>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import mixin from "../../common/mixin/mixins";
import { mapState, mapActions } from "vuex";
export default {
  name: 'JNJUserMain',
  data() {
    return {
      userId: '',
      userDetails: {},
      OthersInfo: {},
      followState: 0,
      FavoritesPopup: false,
      ArtCount: 0,
      CollectCount: 0,
      LikeCount: 0,
      CustomerServicePopup: false,
      LogoutPopup: false,
      articleList: [],
      liveDetailes: {},
      albumList: []
    }
  },
  mixins: [mixin],
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    if(this.$route.query.otherId) {
      this.miniProgramShare(this.$route.query.otherId);
      this.$axios.post('/Api/Api/Web/Customer/GetCustmAll', {
        uid: this.$route.query.otherId
      }).then(res => {
        let data = res.Data;
        this.OthersInfo = data;
        this.getMyInfo();

        if(data.Id != this.userInfo.Id) {
          this.getOthersInfo(data.Id);
          this.getFollowState();
          this.getLive(data.Id);
          this.getArticleList(data.Id);
          this.getAlbumList(data.Id);
          this.BuriedPoint(6, '个人中心', '', '/xgPersonal', this.$route.query.sourceId ? this.$route.query.sourceId : '', data.Id, this.$route.query.sourceType ? this.$route.query.sourceType : '');
        } else {
          this.getLive(this.userInfo.Id); 
          this.getArticleList(this.userInfo.Id);
          this.getAlbumList(this.userInfo.Id);
          this.BuriedPoint(6, '个人中心', '', '/xgPersonal', this.$route.query.sourceId ? this.$route.query.sourceId : '', '', this.$route.query.sourceType ? this.$route.query.sourceType : '');
        }
      })
    } else {
      this.getJJMTUserId(this.userInfo.Id);
      this.getMyInfo();
      this.getLive(this.userInfo.Id); 
      this.getArticleList(this.userInfo.Id);
      this.getAlbumList(this.userInfo.Id);
      this.BuriedPoint(6, '个人中心', '', '/xgPersonal', this.$route.query.sourceId ? this.$route.query.sourceId : '', '', this.$route.query.sourceType ? this.$route.query.sourceType : '');
    }
    
    this.$store.commit("changeNavbarIndex", 2);
  },
  activated() {
    if(this.$route.query.otherId) {
      this.miniProgramShare(this.$route.query.otherId);
    } else {
      this.getJJMTUserId(this.userInfo.Id);
    }
    this.$store.commit('changeNavbarIndex', 2);
  },
  methods: {
    ...mapActions(['setUserInfo']),
    async getMyInfo() {
      let res = await this.$axios.post('/Api/Api/Web/Customer/GetUserInfo', {
        id: this.userInfo.Id
      });
      if(!this.$route.query.otherId || this.OthersInfo.Id == this.userInfo.Id) {
        this.userDetails = res.Data;
      }
      this.setUserInfo({userInfo: res.Data});
      sessionStorage.setItem("userInfo", JSON.stringify(res.Data));
    },
    async getOthersInfo(id) {
      let res = await this.$axios.post('/Api/Api/Web/Customer/GetUserInfo', {
        id: id,
        UserAttentionId: this.userInfo.Id
      });
      this.userDetails = res.Data;
    },
    getJJMTUserId(userid) {
      this.$axios.get('/Api/Api/Web/Customer/GetJJMTUserId?userid=' + userid).then(res => {
        this.miniProgramShare(res.Data);
      })
    },
    miniProgramShare(userid) {
      wx.miniProgram.postMessage({
        data: {
          share: {
            title: '个人中心',
            imageUrl: process.env.VUE_APP_PERRONAL_IMG + userid,
            path: `/pages/personal/personal?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + '/xgPersonal')}&otherId=${userid}&sourceType=7`,
            contentId: ''
          }
        }
      })
    },
    getFollowState() {
      this.$axios.get('/Api/Api/Web/Customer/GetState?uaid=' + this.OthersInfo.Id).then(res => {
        this.followState = res.Data;
      })
    },
    getLive(id) {
      this.$axios.get('/Api/Api/Web/Customer/GetLive?uid=' + id).then(res => {
        this.liveDetailes = res.Data;
      })
    },
    getArticleList(id) {
      this.$axios.post('/Api/Api/Web/Customer/GetUserArt?userid=' + id).then(res => {
        this.articleList = res.Data;
      })
    },
    getAlbumList(id) {
      this.$axios.post('/Api/Api/Web/Album/GetAlbumList', {
        UserId: id
      }).then(res => {
        this.albumList = res.Data;
      })
    },
    toMyFavorite() {
      this.BuriedPoint(1, "我的点赞", "", "/myFavorite");
      this.$router.push({
        path: 'myFavorite',
        query: {
          source: 'xg'
        }
      });
    },
    toMyCollection() {
      this.BuriedPoint(1, "我的收藏", "", "/myCollection");
      this.$router.push({
        path: 'myCollection',
        query: {
          source: 'xg'
        }
      });
    },
    toMyMeeting() {
      this.BuriedPoint(1, "我的预约", "", "/myMeeting");
      this.$router.push({
        path: 'myMeeting',
        query: {
          source: 'xg'
        }
      });
    },
    toBrowseRecords() {
      this.BuriedPoint(1, "历史记录", "", "/browseRecords");
      this.$router.push({
        path: 'browseRecords',
        query: {
          source: 'xg'
        }
      });
    },
    toFansFollowList(type) {
      if(!this.$route.query.otherId || this.OthersInfo.Id == this.userInfo.Id) {
        this.$router.push({
          path: 'FansFollowList',
          query: {
            type: type
          }
        });
      }
    },
    showFavorites() {
      if(!this.$route.query.otherId || this.OthersInfo.Id == this.userInfo.Id) {
        this.FavoritesPopup = true;
      }
    },
    follow() {
      this.$axios.post('/Api/Api/Web/Customer/AddUA?auid=' + this.OthersInfo.Id).then((res) => {
        this.followState = 1;
        this.userDetails.FansCount ++;
      });
    },
    unFollow() {
      this.$axios.post('/Api/Api/Web/Customer/UpdateUA?id=' + this.OthersInfo.Id).then((res) => {
        this.followState = 0;
        this.userDetails.FansCount --;
      });
    },
    handlecollect(index) {
      let url = this.articleList[index].IsCollect ? '/Api/Api/Web/Article/DelHandle' : '/Api/Api/Web/Article/Handle';
      this.$axios.post(url, {
        ArticleId: this.articleList[index].Id,
        CustomerId: this.userInfo.Id,
        type: 2
      }).then((res) => {
        this.articleList[index].IsCollect = !this.articleList[index].IsCollect;
      });
    },
    handleLikes(index) {
      let url = this.articleList[index].IsLive ? '/Api/Api/Web/Article/DelHandle' : '/Api/Api/Web/Article/Handle';
      this.$axios.post(url, {
        ArticleId: this.articleList[index].Id,
        CustomerId: this.userInfo.Id,
        type: 3
      }).then((res) => {
        this.articleList[index].IsLive = !this.articleList[index].IsLive;
      });
    },
    toLive(url) {
      let loading = this.$toast.loading({
        message: '进入活动中...',
        forbidClick: true,
      });
      this.$axios.post('/Api/Api/Web/Live/UserLive', {
        uid: this.userInfo.Id,
        url: url
      }).then((res) => {
        loading.clear();
        window.location.href = res.Data;
      });
    },
    toContentPage(id, type) {
      if(type == 3) {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: id,
            source: 'xg'
          }
        });
      } else {
        this.$router.push({
          path: 'contentPage',
          query: {
            id: id,
            type: type,
            source: 'xg'
          }
        });
      }
    },
    toAlbumDetails(id) {
      this.$router.push({
        path: 'albumDetails',
        query: {
          id: id
        }
      });
    },
    toPersonalPoster() {
      this.$router.push({
        path: 'PersonalPoster',
        query: {
          type: 2
        }
      });
    },
    toLiveHome() {
      wx.miniProgram.navigateTo({url: '/pages/liveHome/liveHome'})
    },
    viewAll() {
      this.$router.push({
        path: 'albumList',
        query: {
          uid: this.userId
        }
      });
    },
    toTop() {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  min-height: 100%;
  padding: 10px 17px 80px;
  background-color: #F9F9F9;
  box-sizing: border-box;
  .goPersonal {
    position: relative;
    z-index: 99;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #FFFFFF;
    margin-bottom: 8px;
    img {
      display: block;
      width: 12px;
      margin-right: 5px;
    }
  }
  .userInfoBox {
    position: relative;
    z-index: 9;
    width: 100%;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 10px;
    padding: 10px 15px;
    box-sizing: border-box;
    color: #4A4A4A;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
    .userInfo {
      display: flex;
      margin-bottom: 6px;
      .touxiang {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 2px solid #FFFFFF;
        margin-right: 12px;
        margin-left: -2px;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .info {
        display: flex;
        flex-direction: column;
        // justify-content: center;
        .name {
          color: #000000;
          font-size: 18px;
          font-weight: bold;
          margin-top: 2px;
          margin-bottom: 2px;
        }
        .positionalName {
          font-size: 12px;
        }
      }
    }
    .hospital {
      display: flex;
      align-items: center;
      margin-top: 5px;
      .hospitalIcon {
        display: block;
        width: 12px;
        margin-right: 6px;
        flex-shrink:0;
      }
      .keshiIcon {
        display: block;
        width: 11px;
        margin-right: 7px;
        flex-shrink:0;
      }
      span {
        max-width: 85%;
        font-size: 12px;
        color: #4A4A4A;
      }
    }
    .dataBox {
      display: flex;
      // padding: 5px 0;
      height: 56px;
      margin-top: 8px;
      background-color: #FFFFFF;
      border-radius: 10px;
      .dataItem {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex: 1;
        .dataNum {
          display: block;
          font-size: 18px;
          font-weight: bold;
          color: #4A4A4A;
        }
        .dataName {
          display: block;
          font-size: 12px;
          color: #979797;
          margin-top: 2px;
        }
        .dashed {
          position: absolute;
          top: 30%;
          right: 0;
          width: 1px;
          height: 40%;
        }
      }
    }
    .followBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 15px;
      right: 15px;
      height: 25px;
      border-radius: 25px;
      font-size: 12px;
      padding: 0 8px;
      box-sizing: border-box;
      .plusIcon {
        display: block;
        width: 16px;
        margin-right: 2px;
      }
    }
    .follow {
      color: #FFFFFF;
      background-color: #EB1700;
    }
    .unfollow {
      color: #000000;
      background-color: #FFFFFF;
      border: 1px solid #D8D8D8;
    }
    .shareBox {
      position: absolute;
      top: 12px;
      right: 12px;
      .shareIcon {
        width: 15px;
        margin-bottom: 3px;
      }
    }
    .customerServiceBox {
      display: flex;
      position: absolute;
      top: 12px;
      right: 42px;
      .customerServiceIcon {
        width: 17px;
        margin-bottom: 3px;
      }
    }
    .customerServiceBox_en {
      right: 12px;
    }
  }
  .menuBox {
    display: flex;
    margin: 15px 0 12px;
    border-radius: 8px;
    .menuItem {
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        display: block;
        width: 35px;
        margin: 0 auto;
      }
      span {
        font-size: 12px;
        color: #4A4A4A;
      }
      .enMenuTitle {
        font-size: 13px !important;
      }
    }
  }
  .column {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    background-color: #FFFFFF;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-top: 10px;
    padding: 0 18px;
    img {
      display: block;
      width: 8px;
    }
    span {
      font-size: 14px;
      color: #564C47;
    }
  }
  .contentBox {
    background-color: #FFFFFF;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-top: 10px;
    padding: 10px 12px;
    .contentTitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: #000000;
      margin-bottom: 10px;
      img {
        display: block;
        margin-right: 6px;
      }
      .viewAll {
        display: flex;
        align-items: center;
        span {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.6);
        }
        .moreIcon {
          color: #EB1700;
          font-size: 12px;
          font-weight: bold;
          margin-left: 2px;
        }
      }
    }
    .notContent {
      min-height: 30px;
      border-radius: 8px;
      background-color: #F8F8FA;
      padding: 10px;
      .notContent_btn {
        width: 80px;
        height: 30px;
        border-radius: 30px;
        line-height: 30px;
        text-align: center;
        color: #FFFFFF;
        font-size: 13px;
        font-weight: bold;
        background-color: #EB1700;
        margin: 0 auto;
      }
      .text {
        display: block;
        text-align: center;
        line-height: 30px;
        font-size: 12px;
        font-weight: bold;
        color: #7B7B7B;
      }
      .text_en {
        display: block;
        text-align: center;
        line-height: 20px;
        font-size: 12px;
        font-weight: bold;
        color: #7B7B7B;
      }
    }
    .notContent_en {
      padding: 10px 0;
    }
    .liveBox {
      .liveCoverBox {
        position: relative;
        border-radius: 6px 6px 0 0;
        overflow: hidden;
        .liveCover {
          display: block;
          width: 100%;
          border-radius: 6px;
        }
        .playIcon {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 40px;
          transform: translate(-20px, -20px);
        }
        .liveStatus {
          position: absolute;
          top: 0;
          left: 0;
          min-width: 50px;
          height: 16px;
          line-height: 16px;
          text-align: center;
          font-size: 8px;
          color: #FFFFFF;
          background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
          border-radius: 0 0 8px 0;
          padding: 0 4px;
          box-sizing: border-box;
        }
      }
      .liveTitle {
        font-size: 14px;
        line-height: 18px;
        margin-top: 10px;
        color: #3D3D3D;
      }
    }
    .articleList {
      .articleItem {
        display: flex;
        .articleCover {
          position: relative;
          width: 40%;
          border-radius: 6px;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
          }
          .sourceTag {
            position: absolute;
            top: 0;
            left: 0;
            min-width: 50px;
            height: 16px;
            line-height: 16px;
            text-align: center;
            font-size: 8px;
            color: #FFFFFF;
            background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
            border-radius: 0 0 8px 0;
            padding: 0 4px;
            box-sizing: border-box;
          }
        }
        .articleInfo {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 60%;
          padding-left: 8px;
          box-sizing: border-box;
          color: #3D3D3D;
          .articleTitle {
            font-size: 12px;
            line-height: 18px;
          }
          .articleData {
            .operateBox {
              display: flex;
              justify-content: flex-end;
              align-items: center;
            }
            .operateItem {
              display: flex;
              align-items: center;
              font-size: 10px;
              margin-left: 10px;
            }
            .operateIcon {
              display: block;
              width: 12px;
              margin-right: 2px;
            }
            .watch {
              width: 13px;
            }
            .like {
              width: 11px;
            }
            .collect {
              width: 11px;
            }
          }
        }
      }
      .articleItem:not(:last-of-type) {
        margin-bottom: 10px;
      }
    }
    .albumList {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 8px;
      .listItem {
        .albumCover {
          position: relative;
          .cover {
            display: block;
            width: 100%;
            border-radius: 8px;
          }
          .cornerMark {
            position: absolute;
            top: 0;
            right: 8px;
            width: 25px;
          }
        }
        .albumTitle {
          height: 34px;
          line-height: 18px;
          font-size: 12px;
          color: #3D3D3D;
          margin: 4px 2px 0;
        }
      }
    }
  }
  .contactUs {
    font-size: 12px;
    line-height: 20px;
    color: #A0A0A0;
    text-align: center;
    margin-top: 20px;
    span {
      color: #EB1700;
    }
  }
  .unsubscribe {
    font-size: 12px;
    line-height: 20px;
    color: #A0A0A0;
    text-align: right;
    margin: 10px 0 0;
  }
}
.container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 163px;
  background-color: #EB1700;
  z-index: 1;
}
.CustomerServicePopup {
  width: 90%;
  border-radius: 14px;
  padding: 30px 0;
  box-sizing: border-box;
  text-align: center;
  overflow-y: visible;
}
.close {
  position: absolute;
  top: -7px;
  right: -7px;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  border-radius: 50%;
  background-image: linear-gradient(130deg, #EB1700 50%, #C33BBB 80%, #8C3BBB 100%);
  z-index: 99;
  .closeIcon {
    color: #FFFFFF;
  }
}
.customerServiceQRcode {
  span {
    font-size: 15px;
    font-weight: bold;
    color: transparent;
    background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 60%, #8C3BBB 100%);
    background-clip: text;
    line-height: 22px;
  }
  .QRcodeBox {
    width: 100px;
    height: 100px;
    background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
    margin: 15px auto 0;
    padding: 5px;
    .QRcode {
      width: 100%;
      height: 100%;
      background-color: #FFFFFF;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
.LogoutPopup {
  width: 90%;
  border-radius: 14px;
  padding: 20px 10px;
  box-sizing: border-box;
  text-align: center;
  overflow-y: visible;
  .warningIcon {
    display: block;
    width: 25px;
    margin: 0 auto 10px;
  }
  span {
    font-size: 14px;
    color: #606060;
    line-height: 22px;
  }
  .enLogoutTips {
    font-size: 12px !important;
  }
}
.FavoritesPopup {
  width: 84%;
  border-radius: 14px;
  text-align: center;
  overflow-y: visible;
  .FavoritesBox {
    .FavoritesTitle {
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      color: #606060;
      border-bottom: 1px solid #606060;
    }
    .FavoritesContent {
      padding: 30px 0;
      display: inline-block;
      .FavoritesItem {
        display: flex;
        align-items: center;
        font-size: 16px;
        margin-bottom: 30px;
        color: #606060;
        img {
          display: block;
          width: 25px;
          margin-right: 5px;
        }
        .title {
          display: inline-block;
          width: 120px;
          margin-right: 20px;
        }
        .enTitle {
          text-align: left;
          display: inline-block;
          width: 185px;
          font-size: 15px;
          margin-right: 20px;
        }
        .num {
          font-weight: bold;
        }
      }
      .FavoritesConfirm {
        width: 120px;
        height: 30px;
        line-height: 30px;
        background-image: url('../../assets/images/btn_bg1.png');
        background-size: 100% 100%;
        color: #FFFFFF;
        font-size: 14px;
        margin: 0 auto;
      }
    }
  }
}
.toTop {
  position: fixed;
  right: 8px;
  bottom: 68px;
  width: 40px;
  height: 40px;
  text-align: center;
  padding-bottom: 1.5em;
  padding-top: 0.5em;
  z-index: 999;
  a {
    scroll-behavior: smooth;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>